import xregexp from 'xregexp';

function lspName() {
  // \p{L} - unicode category - Letter  (any language)
  const NAME_REGEXP = xregexp("^[\\.\\-\\'\\s\\p{L}]*$");

  return {
    require: 'ngModel',
    restrict: 'A',
    link: (...args) => {
      args[3].$validators.lspName = (value) => NAME_REGEXP.test(value);
    },
  };
}

export default lspName;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-name-validator/lsp-name-directive.js